
import { Component, Vue } from "nuxt-property-decorator";
import federalStates from "~/assets/data/federalStates";
import EsyCard from "~/components/atoms/sectioning/EsyCard.vue";
import EsyCardContent from "~/components/atoms/sectioning/EsyCardContent.vue";
import RouterLink from "~/components/atoms/text/RouterLink.vue";
import AlphabetNavigation from "~/components/molecules/display/AlphabetNavigation.vue";
import BreadCrumb from "~/components/molecules/display/BreadCrumb.vue";
import PlaceList from "~/components/organisms/display/PlaceList.vue";
import TopDealersList from "~/components/organisms/display/TopDealersList.vue";
import { generateBreadcrumbJsonLd } from "~/operations/jsonld-helper";
import { generateMetaTags } from "~/operations/meta-helper-functions";
import {
  Dealer,
  isApiEsyoilError,
  isApiEsyoilErrorResponse,
  TopDealerAndUserRatingsResponse,
} from "~/types/ApiEsyoil";

@Component({
  components: {
    AlphabetNavigation,
    BreadCrumb,
    EsyCard,
    EsyCardContent,
    PlaceList,
    RouterLink,
    TopDealersList,
  },
  async asyncData({ env, error, $axios }) {
    try {
      const response = await $axios.get<TopDealerAndUserRatingsResponse>(
        `${env.API_ESYOIL}${env.PARTNERS_AND_RATIUNGS}/00000?limit=10`,
      );

      if (isApiEsyoilError(response.data)) {
        return error({
          statusCode: 500,
          message: "ein unerwarteter Fehler ist aufgetreten.",
        });
      }

      if (!isApiEsyoilErrorResponse(response.data)) {
        return { topDealers: response.data.data.dealerList };
      }
    } catch {
      return error({ statusCode: 404 });
    }
  },
})
export default class DealersOverview extends Vue {
  topDealers: Dealer[] = [];

  federalStates = federalStates;

  get breadCrumbs() {
    return [
      {
        name: "Heizölhändler",
        linkUrl: "/heizoelhaendler",
      },
    ];
  }

  get states() {
    return federalStates.map((state) => ({
      name: state.name,
      link: {
        title: state.title,
        path: `/heizoelhaendler/bundeslaender/${state.slug}`,
      },
    }));
  }

  head() {
    return {
      ...generateMetaTags(this.$route.path, "dealer-overview"),
      link: [
        {
          rel: "canonical",
          href: "/heizoelhaendler",
        },
      ],
      script: [
        {
          json: generateBreadcrumbJsonLd(this.breadCrumbs),
          type: "application/ld+json",
        },
      ],
    };
  }
}
